import { render, staticRenderFns } from "./NewsOne.vue?vue&type=template&id=797d345d&scoped=true"
import script from "./NewsOne.vue?vue&type=script&lang=js"
export * from "./NewsOne.vue?vue&type=script&lang=js"
import style0 from "./NewsOne.vue?vue&type=style&index=0&id=797d345d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797d345d",
  null
  
)

export default component.exports